/**
 * cart-discount-error-override.js
 *
 * Replaces Kaching Cart's generic "discount code invalid" error with a
 * helpful, dynamic message when the code in question is OLDBONES15B and
 * the cart subtotal is under $100. Tells the customer exactly how much
 * more they need to add to unlock the discount instead of leaving them
 * with a vague "this code doesn't work" message that drives support tickets.
 *
 * Other invalid codes still show Kaching's default error untouched.
 *
 * Hook target: <div class="kaching-cart__discount-code-errors"><p>...</p></div>
 */
(function () {
  'use strict';

  const TARGET_CODES = ['OLDBONES15B'];
  const MINIMUM_CENTS = 10000;
  const DISCOUNT_LABEL = '$15';
  const INPUT_SELECTOR = '.kaching-cart__discount-code-input';
  const ERROR_SELECTOR = '.kaching-cart__discount-code-errors p';

  let lastTypedCode = '';

  // Capture whatever the user types into the Kaching discount input,
  // even if Kaching clears the field on submit before the error appears.
  document.addEventListener(
    'input',
    function (event) {
      const input = event.target;
      if (!input || !input.classList) return;
      if (!input.classList.contains('kaching-cart__discount-code-input')) return;
      lastTypedCode = (input.value || '').trim().toUpperCase();
    },
    true
  );

  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '$' + dollars;
  }

  function isOverriddenText(text) {
    return /to unlock|orders \$100|first-time customers/i.test(text || '');
  }

  function fetchCartTotalCents() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (cart) {
        if (!cart || typeof cart.total_price !== 'number') return null;
        return cart.total_price;
      })
      .catch(function () {
        return null;
      });
  }

  let inflight = false;
  function maybeOverride() {
    if (inflight) return;
    const para = document.querySelector(ERROR_SELECTOR);
    if (!para) return;
    if (isOverriddenText(para.textContent)) return;
    if (!lastTypedCode || TARGET_CODES.indexOf(lastTypedCode) === -1) return;

    // Hide the original error instantly so the customer never sees the
    // generic Kaching message flash before our replacement lands. Using
    // visibility (not display) preserves layout and prevents the cart
    // drawer from jumping while the cart fetch resolves.
    para.style.visibility = 'hidden';

    const enteredCode = lastTypedCode;
    inflight = true;
    fetchCartTotalCents().then(function (totalCents) {
      let message;
      if (totalCents !== null && totalCents > 0 && totalCents < MINIMUM_CENTS) {
        const remaining = MINIMUM_CENTS - totalCents;
        message =
          enteredCode +
          ' - Add ' +
          formatMoney(remaining) +
          ' more to unlock ' +
          DISCOUNT_LABEL +
          ' off your order.';
      } else {
        message =
          enteredCode +
          ' - This code is valid on orders $100 and up. Add a little more to unlock ' +
          DISCOUNT_LABEL +
          ' off.';
      }
      const stillPara = document.querySelector(ERROR_SELECTOR);
      if (stillPara && !isOverriddenText(stillPara.textContent)) {
        stillPara.textContent = message;
        stillPara.style.visibility = 'visible';
      } else if (stillPara) {
        stillPara.style.visibility = 'visible';
      }
      inflight = false;
    });
  }

  const observer = new MutationObserver(function () {
    maybeOverride();
  });

  function start() {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    maybeOverride();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
